<template>
  <div id="RegistrationReview" v-loading="loading" class="mainDiv">
    <el-tabs
      v-model="reviewStatus"
      type="card"
      @tab-click="handleReviewStatusChange"
    >
      <el-tab-pane
        v-for="item in reviewStatusList"
        :key="item.value"
        :label="item.label"
        :name="item.value"
      ></el-tab-pane>
    </el-tabs>
    <el-form
      ref="query"
      :model="query"
      label-width="120px"
      style="width: 500px; transition: all 0.5s"
      v-show="isShowQuery"
    >
      <el-form-item label="专业：" prop="professionId">
        <el-select
          v-model="query.professionId"
          size="small"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in categoryList"
            :key="item.zyCurrencyCategoryId"
            :label="item.title"
            :value="item.zyCurrencyCategoryId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="课程名：" prop="courseName">
        <el-input
          v-model="query.courseName"
          size="small"
          clearable
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="批次号" prop="batchNum">
        <el-input
          v-model="query.batchNum"
          size="small"
          clearable
          placeholder="请输入"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="准考证号：" prop="admissionCard">
        <el-input
          v-model="query.admissionCard"
          size="small"
          clearable
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="姓名：" prop="zName">
        <el-input
          v-model="query.zName"
          size="small"
          clearable
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="付款时间：" prop="datetime">
        <el-date-picker
          size="small"
          v-model="query.datetime"
          type="datetimerange"
          start-placeholder="开始日期"
          range-separator="至"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="timestamp"
          :unlink-panels="true"
          clearable
          style="width: 100%"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item style="text-align: right">
        <el-button type="primary" size="small" @click="resetQuery('query')"
          >清空</el-button
        >
        <el-button type="primary" size="small" @click="handleQuery"
          >确定</el-button
        >
        <el-button type="primary" size="small" @click="isShowQuery = false"
          >关闭</el-button
        >
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="start" align="middle">
      <el-col :span="10" style="margin-left: 10px">
        <el-button size="small" type="primary" @click="isShowQuery = true"
          >搜索</el-button
        >
        <el-button
          v-show="reviewStatus === '2'"
          size="small"
          type="primary"
          @click="batchPass"
          >批量通过</el-button
        >
        <el-button
          v-show="reviewStatus === '2'"
          size="small"
          type="primary"
          @click="showRegistrationReviewNotPass"
          >批量未通过</el-button
        >
        <el-button
          v-show="reviewStatus === '1' || reviewStatus === '3'"
          size="small"
          type="primary"
          @click="outExcel"
          >导出</el-button
        >
      </el-col>
    </el-row>
    <el-table
      ref="table"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column width="50" label="序号">
        <template slot-scope="scope">{{
          scope.$index + 1 + (pageObj.page - 1) * pageObj.pageSize
        }}</template>
      </el-table-column>
      <el-table-column prop="orderId" label="订单ID"></el-table-column>
      <el-table-column prop="uname" label="用户名"></el-table-column>
      <el-table-column prop="phone" label="手机号（账号）"></el-table-column>
      <el-table-column prop="professionName" label="专业"></el-table-column>
      <el-table-column prop="courseName" label="课程名"></el-table-column>
      <el-table-column prop="admissionCard" label="准考证号"></el-table-column>
      <el-table-column prop="zname" label="姓名"></el-table-column>
      <el-table-column prop="payStatus" label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.payStatus === '1'">待缴费</div>
          <div v-if="scope.row.payStatus === '2'">已取消</div>
          <div v-if="scope.row.payStatus === '3'">已缴费</div>
          <div v-if="scope.row.payStatus === '5'">退款成功</div>
          <div v-if="scope.row.payStatus === '7'">已失效</div>
        </template>
      </el-table-column>
      <el-table-column prop="ptime" label="付款时间">
        <!-- <template #default="scope">{{scope.row.ptime * 1000 | datetimeFormat}}</template> -->
      </el-table-column>
      <el-table-column
        prop="checkName"
        label="审核人"
        v-if="reviewStatus !== '2'"
      ></el-table-column>
      <!-- <el-table-column label="审核时间" v-if="reviewStatus !== '2'">
          <template #default="scope">{{scope.row.zkolApplyUserAuth ? scope.row.zkolApplyUserAuth.createTime : '' | datetimeFormat}}</template>
        </el-table-column> -->
      <el-table-column
        prop="checkTime"
        label="审核时间"
        v-if="reviewStatus !== '2'"
      ></el-table-column>
      <el-table-column
        v-if="reviewStatus === '0'"
        prop="noPassReason"
        label="未通过意见"
      ></el-table-column>
      <el-table-column
        v-if="reviewStatus === '4'"
        prop="noPassReason"
        label="退回意见"
      ></el-table-column>
      <el-table-column label="操作" width="120">
        <template #default="scope">
          <span class="operation" @click="showRegistrationReviewEdit(scope.row)"
            >查看报名信息</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
    <registration-review-edit
      v-if="isShowDialog"
      ref="registrationReviewEdit"
      @close-registration-review-edit="closeRegistrationReviewEdit"
    ></registration-review-edit>
    <registration-review-not-pass
      v-if="isShowDialogNotPass"
      ref="registrationReviewNotPass"
      :uName="uName"
      @close-registration-review-not-pass="closeRegistrationReviewNotPass"
    ></registration-review-not-pass>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import { getUserByUid } from '@/api/courseware/course'
import * as api from '@/api/index'
import * as api2 from '@/api/courseware/coursewareList'
import RegistrationReviewEdit from './RegistrationReview-edit'
import RegistrationReviewNotPass from './RegistrationReview-notPass.vue'
export default {
  name: 'RegistrationReview',
  components: {
    RegistrationReviewEdit,
    RegistrationReviewNotPass,
  },
  data() {
    return {
      userType: '',
      fullname: '',
      institutionId: 0,
      loading: false,
      reviewStatus: '2',
      reviewStatusList: [
        { value: '2', label: '待审核' },
        { value: '1', label: '审核通过' },
        { value: '4', label: '审核退回' },
        { value: '0', label: '审核未通过' },
        { value: '3', label: '已结束学习' },
      ],
      isShowQuery: false,
      // 专业列表
      categoryList: [],
      query: {
        professionId: '',
        courseName: '',
        batchNum: '',
        admissionCard: '',
        zName: '',
        datetime: [],
      },
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      // 选中的数组
      selectedList: [],
      isShowDialog: false,
      isShowDialogNotPass: false,
      uName: '',
    }
  },
  methods: {
    //通过uid获取用户
    getUserByUid() {
      api2.getUserByUid(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          this.userType = data.data.type
          this.fullname = data.data.fullname
          this.getSchoolByUid()
        }
      })
    },
    //获取机构
    getSchoolByUid() {
      api2.getSchoolByUid(this.getUId).then((data) => {
        if (data.data.code === 100000) {
          this.institutionId = data.data.data === null ? '' : data.data.data.id
          this.getList()
        }
      })
    },
    // 监听状态切换
    handleReviewStatusChange() {
      this.pageObj.page = 1
      this.getList()
    },

    // 获取数据
    getList() {
      this.loading = true
      const { page, pageSize } = this.pageObj
      const verifyStatus = this.reviewStatus
      const { professionId, courseName, admissionCard, zName, datetime } =
        this.query
      const [startTime, endTime] = datetime || ['', '']
      api
        .getCourseReviewList({
          page,
          pageSize,
          verifyStatus,
          professionId,
          courseName,
          admissionCard,
          zName,
          startTime,
          endTime,
          uid: this.getUId,
          userType: this.userType,
          mhmId: this.institutionId,
        })
        .then(({ data }) => {
          data = data.data
          this.tableData = data.list
          this.total = data.total
          this.loading = false
        })
    },

    // 获取专业
    getCategoryList() {
      api.getAllCategory().then(({ data }) => {
        this.categoryList = data.data
      })
    },

    // 批量通过
    batchPass() {
      const selectedList = this.selectedList
      const uid = this.getUId
      // console.log(ids)
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      }
      confirmMsg('是否批准通过这些数据？', async () => {
        let obj = {
          ids: '',
          infoType: '',
          sIds: '',
          verifyStatus: '1',
          uid: this.getUId,
          uName: this.uName,
        }
        for (let i = 0; i < selectedList.length; i++) {
          obj.ids += selectedList[i].orderId + ','
          obj.infoType += selectedList[i].infoType + ','
          obj.sIds += selectedList[i].uid + ','
        }
        console.log(selectedList)
        console.log(obj)
        const data = await api.updateApproveStatus(obj)
        console.log(data)
        if (data.data.code === 100000) {
          this.$message({
            type: 'success',
            message: `本次审核通过记录为：${selectedList.length}`,
          })
          this.getList()
        }
      })
    },

    // 导出通过
    outExcel() {
      this.loading = true
      const verifyStatus = this.reviewStatus
      const { professionId, courseName, admissionCard, zName, datetime } =
        this.query
      const [startTime, endTime] = datetime || ['', '']
      api
        .outExcel({
          verifyStatus,
          professionId,
          courseName,
          admissionCard,
          zName,
          startTime,
          endTime,
          uid: this.getUId,
          userType: this.userType,
          mhmId: this.institutionId,
        })
        .then((res) => {
          if (!res.data) {
            return
          }
          const yy = new Date().getFullYear()
          const mm = new Date().getMonth() + 1
          const dd = new Date().getDate()
          const hh = new Date().getHours()
          const mf =
            new Date().getMinutes() < 10
              ? '0' + new Date().getMinutes()
              : new Date().getMinutes()
          const ss =
            new Date().getSeconds() < 10
              ? '0' + new Date().getSeconds()
              : new Date().getSeconds()
          console.log()
          if (this.reviewStatus === '1') {
            var name = '审核通过列表名单' + yy + mm + dd + hh + mf + '.xlsx'
          } else if (this.reviewStatus === '3') {
            var name = '审核已完成列表名单' + yy + mm + dd + hh + mf + '.xlsx'
          }
          var blob = new Blob([res.data])
          var url = window.URL.createObjectURL(blob)
          var aLink = document.createElement('a')
          aLink.style.display = 'none'
          aLink.setAttribute('download', name)
          aLink.href = url
          document.body.appendChild(aLink)
          aLink.click()
          document.body.removeChild(aLink) // 下载完成移除元素
          window.URL.revokeObjectURL(url) // 释放掉blob对象
          this.loading = false
        })
    },

    // 批量不通过
    showRegistrationReviewNotPass() {
      if (this.selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      }
      this.isShowDialogNotPass = true
      this.$nextTick(() => {
        this.$refs.registrationReviewNotPass.init(
          this.selectedList,
          this.getUId
        )
      })
    },

    closeRegistrationReviewNotPass(msg) {
      this.isShowDialogNotPass = false
      if (msg === 'success') {
        this.getList()
      }
    },

    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },

    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getList()
    },

    // 查询
    handleQuery() {
      this.pageObj.page = 1
      this.getList()
    },

    // 重置查询
    resetQuery(formName) {
      this.$refs[formName].resetFields()
      this.handleQuery()
    },

    // 查看报名信息
    showRegistrationReviewEdit(row) {
      this.isShowDialog = true
      this.$nextTick(() => {
        this.$refs.registrationReviewEdit.init(
          row,
          this.reviewStatus,
          this.getUId,
          this.fullname
        )
      })
    },

    closeRegistrationReviewEdit(msg) {
      this.isShowDialog = false
      if (msg === 'success') {
        this.getList()
      }
    },
  },
  async created() {
    this.getCategoryList()
    this.getUserByUid()
    this.uName = (await getUserByUid(this.getUId)).data.data.uname
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
